import { render, staticRenderFns } from "./addaccount.vue?vue&type=template&id=7e152858&scoped=true&"
import script from "./addaccount.vue?vue&type=script&lang=js&"
export * from "./addaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e152858",
  null
  
)

export default component.exports